import * as Ajax from "../../pwa/ajax";

export const checkBomba = () => { 
    const bombaIntrasitio = document.querySelector("#bombaIntrasitio");

    if (bombaIntrasitio === null || bombaIntrasitio === undefined) return;

    queryBomba();
    setInterval(queryBomba, 60000);   
}

const queryBomba = () => {  
    Ajax.get(window.config.Statics.NotaBomba)
            .then(result => {drawnBomba(JSON.parse(result))});
}

const drawnBomba = (json) => {
    const bombaIntrasitio = document.querySelector("#bombaIntrasitio");

    if (bombaIntrasitio === null || bombaIntrasitio === undefined) return;
    
    if(Object.getOwnPropertyNames(json).length > 0){
        const bombaIntrasitioObj = json;
        const html = `<a href="{url}" class="floatFix"> <img src="{imagen}" />
                        <div>
                                <div class="bullet"><div class="circle"></div></div>                                
                                <strong>{tema}</strong>
                                <h1>{titulo}</h1>                                
                                <span>Más información <b class="icon-ir"></b></span>
                        </div>
                        </a>`;

        bombaIntrasitio.classList.add("bomba-interna");
        bombaIntrasitio.classList.add("floatFix");
        bombaIntrasitio.innerHTML = html.replace("{imagen}", bombaIntrasitioObj.Imagen).replace("{tema}", bombaIntrasitioObj.Tema).replace("{titulo}", bombaIntrasitioObj.Titulo)
            .replace("{url}", bombaIntrasitioObj.Url);
    }  
    else{
        bombaIntrasitio.innerHTML = "";
        const classBombaIntransito = document.querySelector("#bombaIntrasitio").classList;

        if(classBombaIntransito.contains("bomba-interna")){
            classBombaIntransito.remove("bomba-interna");
            classBombaIntransito.remove("floatFix");
        } 
    }
}


// WEBPACK FOOTER //
// ./Statics/scripts/common/bombaIntrasitio.js